var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 27C2.465 27 1.66458 26.6695 0.99875 26.0086C0.332917 25.3477 0 24.5531 0 23.625V3.375C0 2.44688 0.332917 1.65234 0.99875 0.991406C1.66458 0.330469 2.465 0 3.4 0H30.6C31.535 0 32.3354 0.330469 33.0013 0.991406C33.6671 1.65234 34 2.44688 34 3.375V23.625C34 24.5531 33.6671 25.3477 33.0013 26.0086C32.3354 26.6695 31.535 27 30.6 27H3.4ZM3.4 23.625H30.6V6.75H3.4V23.625ZM9.35 21.9375L6.97 19.575L11.3475 15.1875L6.9275 10.8L9.35 8.4375L16.15 15.1875L9.35 21.9375ZM17 21.9375V18.5625H27.2V21.9375H17Z",
    fill: "#B72929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgCode);
export default __webpack_public_path__ + "static/media/svgCode.ee761f97bfbc94f2cda8dbd0fadd8448.svg";
export { ForwardRef as ReactComponent };